<template>
  <div class="voteImport">
    <el-button type="primary" size="mini" icon="el-icon-upload" @click="uploadHide = true">
      <slot>导入</slot>
    </el-button>
    <div class="uploadTip" v-show="uploadHide">
      <div class="head">
        <p>文件上传</p>
        <p>
          <i class="el-icon-close" @click="uploadHide = false"></i>
        </p>
      </div>
      <div class="content">
        <el-upload
          class="upload"
          :action="actionUrl"
          ref="voteUpload"
          :limit="1"
          :data="data"
          :on-success="uploadSuccess"
          :before-upload="uploadBefore"
          :on-error="uploadError"
          :show-file-list="true"
          :on-exceed="handleExceed"
          :auto-upload="false">
          <el-button class="fileSelBtn" slot="trigger" size="mini" :round="true" type="primary" plain>选取文件</el-button>
        </el-upload>
      </div>
      <div class="footer">
        <div class="btn">
          <el-button type="primary" size="mini" @click="submitUpload">上传</el-button>
          <el-button type="info" size="mini" @click="uploadHide = false">关闭</el-button>
        </div>
      </div>
    </div>
    <div class="mask" v-show="uploadHide"></div>
  </div>
</template>

<script>
import { devEnvironment, proEnvironment } from '@/assets/js/division';
import {
  getToken
} from '@/utils/auth.js';
export default {
  props:  {
    data: {
      type: Object,
      default(){
        return {
          token: getToken()
        };
      }
    },
    url: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      api: '/api',
      uploadHide: false
    };
  },
  created() {
    this.baseURL = '';
    if (process.env.NODE_ENV === 'development') {
      this.baseURL = devEnvironment;
    } else if (process.env.NODE_ENV === 'production') {
      this.baseURL = 'szwyweb/';
    }
  },
  methods: {
    // 手动上传
    submitUpload () {
      if (!this.$refs.voteUpload.uploadFiles.length) { // 判断是否已经选取了文件
        this.$message({
          type: 'warning',
          message: '请您先选取文件！'
        });
        return;
      }
      this.$refs.voteUpload.submit();
      this.uploadHide = false;
    },
    uploadBefore () {
      this.$emit('before-upload');
    },
    uploadSuccess (response) {
      this.$emit('on-success', response);
    },
    uploadError (err) {
      this.$emit('on-error', err);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    }
  },
  computed: {
    actionUrl () {
      return  this.baseURL + this.url;
    }
  }
};
</script>
<style lang="scss">
  .voteImport {
    .upload {
      .el-upload {
        width: 100%;
      }
    }
  }
</style>

<style lang="scss" scoped>
.voteImport {
  display: inline-block;
  .uploadTip {
    height: 200px;
    width: 400px;
    background: #fff;
    position: fixed;
    left: 50%;
    top: 50%;
    margin-top: -100px;
    margin-left: -200px;
    border: 1px solid #ccc;
    z-index: 1112;
    border-radius: 10px;
    overflow: hidden;
    .head {
      line-height: 30px;
      height: 30px;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ccc;
      background: #f3f5f9;
    }
    .content {
      padding: 10px;
      height: calc(100% - 30px - 36px);
      border-bottom: 1px solid #ccc;
      .upload {
        width: 100%;
      }
      .fileSelBtn {
        width: 100%;
      }
    }
  }
  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: #000;
    opacity: 0.5;
    z-index: 1111;
  }
}
</style>